import { updateReflectionMap } from "@project/emerge/src/editor3d/ReflectionMap";
import { StandardEnvironment } from "@project/emerge/src/new/StandardEnvironment";
import { useThree } from "@react-three/fiber";
import { useEffect, useRef } from "react";
import type { CubeTexture } from "three";

/**
 * Scene without the floor grid, for screenshots that go into a quote.
 *
 * Keeps {@link StandardEnvironment}: it only sets `scene.environment`, which is
 * the lighting and reflection source rather than the visible backdrop. Dropping
 * it to hide the grid would leave the product unlit.
 */
export const CleanScene = () => {
  const { scene } = useThree();
  const envMapRef = useRef<CubeTexture | null>(null);

  const handleEnvironmentCreated = (envMap: CubeTexture) => {
    envMapRef.current = envMap;
    scene.environment = envMap;
    updateReflectionMap(envMap);
  };

  useEffect(() => {
    return () => {
      if (envMapRef.current) {
        scene.environment = null;
      }
    };
  }, [scene]);

  return (
    <StandardEnvironment
      resolution={512}
      isGlobal={true}
      {...{ onCreated: handleEnvironmentCreated }}
    />
  );
};
